import { render } from "./PopularPosts.vue?vue&type=template&id=f2aaa052&scoped=true"
import script from "./PopularPosts.vue?vue&type=script&lang=js"
export * from "./PopularPosts.vue?vue&type=script&lang=js"

import "./PopularPosts.vue?vue&type=style&index=0&id=f2aaa052&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2aaa052"]])

export default __exports__